import { Component, OnInit} from '@angular/core';
import { ROUTES } from './vertical-menu-routes.config';

import { TranslateService } from '@ngx-translate/core';
import { customAnimations } from '../animations/custom-animations';
import { User } from '../../user/user.model';
import { AuthService } from '../auth/auth.service';
// @ts-ignore
import packageJson from '../../../../package.json';

@Component({
  selector: 'app-sidebar',
  templateUrl: './vertical-menu.component.html',
  animations: customAnimations
})
export class VerticalMenuComponent implements OnInit {
  public menuItems: any[];
  level = 0;
  logoUrl = 'assets/img/logo.png';
  logoUrlTed = 'assets/img/TedGroup.png';
  user: User;
  version = packageJson.version;

  constructor(
    public translate: TranslateService,
    private _authService: AuthService,
  ) {
    this.user = this._authService.readUserFromLocalStorage();
  }

  ngOnInit() {
    this.menuItems = ROUTES;
  }

  showMenuItem(menuItem) {
    return menuItem.roles.includes(this.user.role);
  }
}
